<nav class="sidebar flex-shrink-0 d-flex flex-column border-end h-100" [class.collapsed]="collapsed"
  [class.drawer-open]="layout.drawerOpen()" aria-label="Main menu">

  <div class="sidebar-header">
    @if(!collapsed) {
    <span class="logo-text">Menu</span>
    }
    <button class="btn btn-sm btn-light border-0 d-flex align-items-center justify-content-center p-1 ms-auto"
      [attr.aria-label]="layout.isMobile() ? 'Close menu' : (collapsed ? 'Expand menu' : 'Collapse menu')"
      (click)="layout.isMobile() ? layout.closeDrawer() : toggleSidebar()">
      <mat-icon class="text-secondary">{{ layout.isMobile() ? 'close' : (collapsed ? 'menu' : 'menu_open') }}</mat-icon>
    </button>
  </div>

  <div class="sidebar-content custom-scrollbar">

    <!-- Fixed client-side Home entry (the DB menu has no row for it) -->
    <div class="nav-item" [class.active]="isRouteActive('/home')" [matTooltip]="collapsed ? 'Home' : ''"
      matTooltipPosition="right" (click)="onMenuClick({ RouterPath: '/home', MenuName: 'Home' }, $event)">
      <div class="d-flex align-items-center flex-grow-1 overflow-hidden">
        <div class="icon d-flex align-items-center"><mat-icon class="fs-5">home</mat-icon></div>
        <span class="menu-text">Home</span>
      </div>
    </div>

    @for(menu of userMenus; track menu.MenuID) {

    <!-- Case 1: Group/Parent with Children -->
    @if(menu.children.length > 0) {
    <div class="nav-item group-header clickable" [class.expanded]="menu.IsOpen"
      [matTooltip]="collapsed ? menu.MenuName : ''" matTooltipPosition="right"
      (click)="toggleMenu(menu, $event)">

      <div class="d-flex align-items-center flex-grow-1 overflow-hidden">
        @if(menu.Svg_Default){
        <div class="icon" [innerHtml]="menu.Svg_Default | sanitizer : 'html'"></div>
        }
        <span class="menu-text">{{ menu.MenuName }}</span>
      </div>

      @if(!collapsed) {
      <mat-icon class="expand-arrow fs-5 text-secondary">
        chevron_right
      </mat-icon>
      }
    </div>

    @if(menu.IsOpen && !collapsed) {
    <div class="submenu-container">
      @for(child of menu.children; track child.MenuID) {
      <div class="submenu-item" [class.active]="isRouteActive(child.RouterPath)" (click)="onMenuClick(child, $event)">
        {{ child.MenuName }}
      </div>
      }
    </div>
    }
    }

    <!-- Case 2: Direct Link -->
    @else {
    <div class="nav-item" [class.active]="isRouteActive(menu.RouterPath)"
      [matTooltip]="collapsed ? menu.MenuName : ''" matTooltipPosition="right"
      (click)="onMenuClick(menu, $event)">

      <div class="d-flex align-items-center flex-grow-1 overflow-hidden">
        @if(menu.Svg_Default){
        <div class="icon" [innerHtml]="menu.Svg_Default | sanitizer : 'html'"></div>
        }
        <span class="menu-text">{{ menu.MenuName }}</span>
      </div>
    </div>
    }

    }
  </div>



</nav>
